// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6406) return "static/chunks/6406-6d99f40567a7343f.js";
	if (chunkId === 2084) return "static/chunks/9b0008ae-7c434d6f605d31d1.js";
	if (chunkId === 1029) return "static/chunks/1029-e7f10aba161ac005.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"6603":"f5ef5e1c","9367":"b536a0f1"}[chunkId] || chunkId) + "." + {"2357":"c43ecb7a69b5393e","2793":"26835cd6d554d5e6","4738":"3fb2c74a48229a95","5847":"91ea28cd274250cd","6225":"e58909ce6569699a","6603":"e2add2f7b7e32367","7957":"a2125fd4dfbddb0a","8783":"3a17ab2d016a3e4d","9367":"e815b61395e14dc0"}[chunkId] + ".js";
};